import { useEffect } from "react"
import { verifyOtpSchema } from "./schema"
import { Field, Form, Formik } from "formik"
import { useNavigate } from "react-router-dom"
import { useVerifyOTP } from "../../hooks/useTwoFa"
import {
  getRefreshToken,
  isOtpVerified,
  saveRememberMeToken,
  setOtpVerification,
} from "../../utils"
import routePaths from "../../constants/path"
import TextField from "../../components/TextField"
import ApiError from "../../components/ApiError"
import { useLogout } from "../../hooks/useAuth"

const VerifyOtpForTwoFa = () => {
  const navigate = useNavigate()
  const {
    isPending: verifyingOTP,
    mutate: verifyOTP,
    error: verifyOTPError,
  } = useVerifyOTP()
  const { mutate: logout } = useLogout()
  const otpVerification = isOtpVerified()

  useEffect(() => {
    if (otpVerification) {
      navigate(routePaths.homepage)
    }
  }, [otpVerification, navigate])

  const handleLogout = () => {
    const refreshToken = getRefreshToken()
    logout(refreshToken.token, {
      onSuccess: () => {
        navigate(routePaths.login)
      },
    })
  }

  const handleSubmit = (values) => {
    verifyOTP(values, {
      onSuccess: (response) => {
        saveRememberMeToken(response?.rememberMeToken)
        setOtpVerification(true)
        navigate(routePaths.homepage)
      },
      onError: (err) => {
        console.error(err)
      },
    })
  }

  return (
    <div className="flex flex-col gap-3 mt-4 w-96	mx-auto px-10 py-8 bg-white rounded-lg">
      <h3 className="text-center text-xl font-bold">
        Two-Factor Authentication
      </h3>
      <Formik
        enableReinitialize
        initialValues={{ otp: "", rememberMe: false }}
        validationSchema={verifyOtpSchema}
        onSubmit={handleSubmit}
      >
        <Form className="flex flex-col gap-6">
          <TextField
            autofocus={true}
            label="Authentication Code"
            name="otp"
            placeholder="Enter 6-digit code"
          />
          <ApiError axiosError={verifyOTPError} />
          <div className="flex ml-2 gap-2">
            <Field id="rememberMe" name="rememberMe" type="checkbox" />
            <label className="text-sm" htmlFor="rememberMe">
              Remember Me
            </label>
          </div>
          <button
            className="w-full bg-secondary hover:bg-secondary_dark text-white px-6 py-2 rounded-lg disabled:bg-gray-400"
            disabled={verifyingOTP}
            type="submit"
          >
            Verify
          </button>
        </Form>
      </Formik>
      <div className="mt-4 w-full flex flex-col gap-3">
        <p>
          Open your two-factor authenticator app to view your authentication
          code.
        </p>
        <button
          className="text-secondary underline text-center"
          onClick={handleLogout}
        >
          Back to Login
        </button>
      </div>
    </div>
  )
}

export default VerifyOtpForTwoFa
